module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"current_reward":"目前回饋","remaining_reward":"剩餘可獲得回饋"}}')
  delete Component.options._Ctor
}
